"use client";
import { createContext, useContext } from "react";
export type AuthUser = {
  id: number;
  name: string;
  username: string;
  email: string;
  role: string;
  partner_id?: number | null;
  member_id?: number | null;
};
type AuthContextValue = {
  user: AuthUser;
  logout: () => Promise<void>;
  can: (view: string) => boolean;
};
export const AuthContext = createContext<AuthContextValue | null>(null);
export function useAuth() {
  const v = useContext(AuthContext);
  if (!v) throw new Error("AuthContext ausente");
  return v;
}
